import { Component, OnInit,ViewChild, Inject, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilterSettingsModel, IFilter, GridComponent, DataStateChangeEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { careCordinatorList, searchfilterDetails, sortingObj, functionpermission, GetCareListBo, WhereCondition } from './care-coordinator.model';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/service/general.service';
import { Observable } from 'rxjs';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { ColumnChangeBO, columnWidth } from '../list/list.model';
import { takeUntil } from 'rxjs/operators';
// import { emailValidator } from '../password/password.component';
import { CommonApiService } from 'src/app/commonapiservice';

@Component({
  selector: 'app-care-coordinator',
  templateUrl: './care-coordinator.component.html',
  styleUrls: ['./care-coordinator.component.scss']
})
export class CareCoordinatorComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  CareArray: careCordinatorList[];
  checkEmailValidation:boolean=false;
  Care: careCordinatorList = new careCordinatorList();
  CareSendBO: GetCareListBo = new GetCareListBo();
  conditionlist: WhereCondition[] = [];
  CareId: any;
  conditionData: WhereCondition = new WhereCondition();
  @Input() fromClient: string;
  @Output() emitcarecode = new EventEmitter<number>()
  clientEnable: boolean = false;
  clientedit: boolean = false;
  CareForm: FormGroup;
  filterItems: { [key: string]: string } = {
    'Coordinator_Name': 'Name',
    'county': 'County',
    'PhoneNumber': 'PhoneNumber',
    'Fax': 'Fax',
    'AlternateFax': 'AlternateFax',
    'Email': 'Email'
  };
  SearchText: string = '';
  SearchColumn: { [key: string]: string } = { 'Coordinator_Name': 'Name' };
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  initialPage: object;
  CareDatalist: any = [];
  filterOptions: FilterSettingsModel;
  @ViewChild('grid') public grid: GridComponent;
  public filterSettings: object;
  filter: IFilter;
  Filter_drop: searchfilterDetails;
  pagshort: sortingObj = new sortingObj();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public isinitialLoad: boolean = false;
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  ColumnArray: columnWidth[];
  ModelType: string = 'edit';
  fp: functionpermission;
  valuechange: any = [];
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  phoneNumber = "^(\+\d{1,3}[- ]?)?\d{10}$";

  constructor(public http: HttpClient, private formBuilder: FormBuilder, public global: GlobalComponent,public CommonAPI: CommonApiService, public toastrService: ToastrService, public general: GeneralService) {
    this.global.agencyList();
    this.data = CommonAPI;
    this.CareForm = this.formBuilder.group({
      Coordinator_Name: [' ', Validators.required],
      PhoneNumber: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      Email: ['', Validators.compose([this.global.emailRegexValidator()])],
      Fax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      AlternateFax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      County: ['']
    });
  }

  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.CareSendBO.orderColumn = state.sorted[0].name;
        this.CareSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      state.action.currentFilterObject.field === "PhoneNumber" ? state.action.currentFilterObject.value = state.action.currentFilterObject.value.replace(' ', "").replace('(', "").replace(')', "").replace('-', "") : state.action.currentFilterObject.value;
      this.CareSendBO.field = state.action.currentFilterObject.field;
      this.CareSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.CareSendBO.operator = state.action.currentFilterObject.operator;
      this.CareSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.CareSendBO.field = "Coordinator_Name";
        this.CareSendBO.matchCase = false;
        this.CareSendBO.operator = "startswith";
        this.CareSendBO.value = "";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Carecoordinator.Pagesize != state.take) {
          this.arraycol[0].Carecoordinator.Pagesize = state.take
          // this.SaveColumnwidth();
        }
      }
    }
    this.getCare();
  }
  ngOnInit(): void {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0|| this.global.globalAgencyId=='00000000-0000-0000-0000-000000000000' ) {
      return;
    }
    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.SearchColumn.key = 'Coordinator_Name';
    this.SearchColumn.value = 'Name';
    this.getCare();
    if (this.fromClient == "edit") {
      this.clientEnable = true;
    }
    if (this.fromClient == "view") {
      this.clientedit = true;
    }
    this.fp = new functionpermission();
    this.filepermissionget();
    this.filterSettings = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
  }
  filepermissionget() {
    let params = new URLSearchParams();
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    params.append("pagecode", "CareCoordinator");
    // if(this.global.roleId != 'null')
    // params.append("roleId", this.global.roleId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].Carecoordinator.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].Carecoordinator.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].Carecoordinator.ShowColumns.length != count1 || this.arraycol[0].Carecoordinator.HideColumns.length != count) {
          this.arraycol[0].Carecoordinator.ShowColumns = showarr;
          this.arraycol[0].Carecoordinator.HideColumns = hidearr;
          // this.SaveColumnwidth();
        }
      }
    }
    this.CareSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.CareSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // ============================================
  actionHandler(args) {
    if (args.requestType == "sorting") {
    }
    else if (args.requestType == "filtering") {
    }
  }

  ///=================Cose carecoordinator=================================////
  closecare() {
    document.getElementById('modal').click();
  }
  customiseCell(args: QueryCellInfoEventArgs) {
    args.data['PhoneNumber'] == this.general.converPhoneGoogleLib(args.data['PhoneNumber']);
  }

  //===================================Show column settings===================//
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50); // give X and Y axis
  }
  // ===================================

  CareCreateupdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.CareForm.reset();
      this.Care = new careCordinatorList();
      this.valueschanges();
    }
    else {
      this.CareForm.controls.Email?.setErrors(null)
      this.ModelType = 'edit';
      this.valueschanges();
    }
  }
  ////////////////////////////////////////////////////
  selectCaredetails(careDetails: careCordinatorList) {
    // console.log(careDetails,"careDetails")
    this.Care = JSON.parse(JSON.stringify(careDetails));
    // console.log(this.Care)
  }
  ////////////////////////////////////////////////////////////
  DemographicPhoneFormat() {
    this.Care.phoneNumber = this.general.converPhoneGoogleLib(this.Care.phoneNumber);
  }
  // ////////////////////////////////////////////////////////////
  DemographicPhoneFormat1() {
    this.Care.fax = this.general.converPhoneGoogleLib(this.Care.fax);
  }
  // /////////////////////////////////////////////////////////////
  DemographicPhoneFormat2() {
    this.Care.alternateFax = this.general.converPhoneGoogleLib(this.Care.alternateFax);
  }
  // //////////////////////////////////////////////////////////
  Refresh() {
    this.SearchText = "";
    this.CareSendBO.field = 'Coordinator_Name';
    this.CareSendBO.value = "";
    this.CareSendBO.pageitem = 10;
    this.CareSendBO.currentpageno = 1;
    this.pagshort = new sortingObj();
    this.getCare();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  paginationChange(event) {
    this.pagshort.currentPgNo = event;
    this.getCare();
  }
  // /////////////////////////////////////////////////////////////
  pageItemsChage(pageitems) {
    this.pagshort.itemperpage = pageitems;
    this.getCare();
  }
  // // //////////////////////////////////////////////////////////////
  Search() {
    this.CareSendBO.field = this.SearchColumn.key;
    this.CareSendBO.value = this.SearchText;
    this.CareSendBO.pageitem = 10;
    this.CareSendBO.currentpageno = 1;
    this.pagshort.currentPgNo = 1;
    this.getCare();
  }
  // // ///////////////////////////////////////////////////////////
  onKeydown(event) {
    if (event.key === "Enter") {
      this.Search();
    }
  }
  //////////////////////////////Set default value for searchcolumn////////////////////
  setDefaultValue() {
    this.SearchText = "";
    if (this.SearchColumn == undefined)
      this.SearchColumn = {
        'Coordinator_Name': 'Name'
      };
  }
  // //////////////////////////////////////////////////////////

  SaveOrUpdateCare() {

    var saveList: careCordinatorList = JSON.parse(JSON.stringify(this.Care));
    saveList.phoneNumber = this.general.reconverPhoneGoogleLib(saveList.phoneNumber);
    saveList.fax = this.general.reconverPhoneGoogleLib(saveList.fax);
    saveList.alternateFax = this.general.reconverPhoneGoogleLib(saveList.alternateFax);
    let url = "api/ClientCareCoordinator/SaveClientCareCoordinator";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(saveList,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      if (data) {
        this.valueschanges();
        if (this.ModelType == 'new') {
          document.getElementById('openModal1').click();
          this.toastrService.success('Care Coordinator saved successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getCare();
        } else {
          document.getElementById('openModal1').click();
          this.toastrService.success('Care Coordinator updated successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getCare();
        }

      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  // /////////////////////////////////////////////////////////////////////

  getStatus() {
    let url = "api/ClientCareCoordinator/GetCareCoordinatorList";
    this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.CareArray = data;
    })
  }
  deleteCare() {
    let url = "api/ClientCareCoordinator/DeleteCareCoordinator/"
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.Care.id,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        document.getElementById('openModal2').click();
        this.toastrService.success('Care Coordinator Deleted successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getCare();
      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    );
  }
  getCare() {
    let url = "api/ClientCareCoordinator/GetCareCoordinatorListFilter?"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.CommonAPI.outputValues(url, this.CareSendBO, responseData,"");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.CareDatalist =(data.result);
      this.CareDatalist?.map(element => {
        // console.log(this.CareDatalist," CareDatalist")
        element.phoneNumber = element.phoneNumber != null ? this.general.converPhoneGoogleLib(element.phoneNumber) : null;
        // console.log( element.PhoneNumber, " element.PhoneNumber ")
        element.fax = element.fax != null ? this.general.converPhoneGoogleLib(element.fax) : null;
        element.alternateFax = element.alternateFax != null ? this.general.converPhoneGoogleLib(element.alternateFax) : null;
     })
    //  console.log(this.CareDatalist," CareDatalist")
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
        if (this.global.globalAgencyId != 0) {
          // this.getColumnwidth();
        }
      }
      if (data != null && data.result.length > 15) {
        this.grid.height = '500';
      }
      else {
        this.grid.height = 'auto';
      }
    })
  }
  closecarecoordinator() {
    document.getElementById('openModal2').click();
  }
 
  ////////////////////////////////////////////////////////////////////

  valueschanges() {
    this.valuechange = {
      Name: 0,
      County: 0,
      PhoneNumber: 0,
      Fax: 0,
      AlternateFax: 0,
      Email: 0,
    }
  }
  checkpopup(value) {
    if (value == "Name") {
      this.valuechange.Name++;
    }
    if (value == "County") {
      this.valuechange.County++;
    } if (value == "PhoneNumber") {
      this.valuechange.PhoneNumber++;
    } if (value == "Fax") {
      this.valuechange.Fax++;
    }
    if (value == "AlternateFax") {
      this.valuechange.AlternateFax++;
    }
    if (value == "Email") {
      this.checkEmailValidation = false;
      if (this.Care.email != null) {
        if (this.CareForm.controls.Email.errors!= null) {
          if (this.CareForm.controls.Email.errors.invalidEmail) {
            this.checkEmailValidation = true;
            setTimeout(() => {
              this.toastrService.clear();
            }, 3000);
          }
          else {
            this.checkEmailValidation = false;
          }
        }
      }
      this.valuechange.Email++;
    }
  }
  openDialog() {
    if (this.valuechange.Email > 1 || this.valuechange.Name > 1 || this.valuechange.County > 1 ||
      this.valuechange.PhoneNumber > 1 || this.valuechange.Fax > 1 || this.valuechange.AlternateFax > 1) {
      document.getElementById('cancelcarecomodal').click();
    }
    else {
      document.getElementById('openModal1').click();
    }
  }
  closeAddUpdateModal() {
    document.getElementById('openModal1').click();
    document.getElementById('cancelcarecomodal').click();
  }

  //==============================Event emitter=============================================//
  carecodeemit(data) {
    this.emitcarecode.emit(data.id)
  }
  //============================== Tooltip =========================================================//
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.data[args.column.field] != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',


        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  closealertmodal() {
    document.getElementById("cancelcarecomodal").click();
  }
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.grid.refreshHeader();
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
  
      });
      // this.SaveColumnwidth();
    }
  }
  dismissModal() {
    document.getElementById('openModal1').click();

  }

  //......................................exportCareWithPaginationCsv.....................................................
  exportCaseWithPaginationCsv() {
    this.CareSendBO.pageitem = this.grid.pageSettings.pageSize;
    this.CareSendBO.currentpageno = this.grid.pageSettings.currentPage;
    let url = "api/ClientCareCoordinator/GetCarecoordinatorWithPaginationExcel";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.CareSendBO, url, "CareCoordinator.csv");
}
//...........................................exportCareCsv................................................................
exportCaseCsv() {
    let url = "api/ClientCareCoordinator/GetCarecoordinatorExcel";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.CareSendBO, url, "CareCoordinator.csv")
}
public ngOnDestroy(): void {
  this.onDestroy$.next();
}
}

